import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import { GoToButton } from './go.to.button';

import './helping.banner.less';

const HelpingBanner = function () {
  return (
    <div className="o-helpingBanner">
      <div className="m-globalContentContainer m-helpingBanner__container">
        <div className="a-helpingBanner__title"><Trans>helping.banner.title</Trans></div>
        <div className="a-helpingBanner__subtitle"><Trans>helping.banner.subtitle</Trans></div>
        <div className="a-helpingBanner__buttonContainer">
          <GoToButton />
        </div>
        <span className="a-signupForm__separator" />
      </div>
    </div>
  );
};

export default HelpingBanner;
